<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Recherche & Développement' | translate}}</h1>
  </div>
</div>

<div class="container mt-5 pb-3">
    <div class="text-center mb-5">
        <span class="title">{{'Immersive Factory : Départements R&D' | translate}}</span>
    </div>
    <div class="col-12 text-justify-center">
      {{'Au sein de la société Immersive Factory, nous recensons deux pôles de Recherche et Développement (R&D) qui oeuvrent de manière complémentaire :' | translate}}
    </div>
</div>
<hr class="mb-0 pb-0">
<div class="blue py-5">
  <div class="container">
    <div class="block row">
        <div class="col-6 text-justify-center separator p-5">
            <div class="rd-icon">
                <app-svg-icon [src]="'assets/svg/VR_Casque_2021.svg'" [size]="'50px'"></app-svg-icon>
            </div>
            <p class="text-bleu mt-3 mb-2 text-uppercase">{{'R&D - Technologies et Réalité Virtuelle' | translate}}</p>
            <p>{{'r&d_para_2' | translate}}</p>
        </div>
        <div class="col-6 text-justify-center separator p-5">
            <div class="rd-icon">
                <app-svg-icon [src]="'assets/svg/gamification-ludopedagogy.svg'" [size]="'43px'"></app-svg-icon>
            </div>
            <p class="text-bleu mt-3 mb-2 text-uppercase">{{'R&D - Gamification et Ludopédagogie' | translate}}</p>
            <p>{{'Dirigé par Julian Alvarez, ce deuxième pôle vise à assurer une veille et une recherche appliquée dans les domaines relevant des usages et des médiations autour des dispositifs techniques gamifiés à l’instar de simulateurs et des serious games impliquant notamment des modalités de types Réalité Virtuelle ou environnements virtuels. En parallèle, l’objectif de ce département est de concevoir et d’évaluer des approches ludopédagogiques dans le cadre de formations, principalement dans le domaine HSE.' | translate}}</p>
        </div>
    </div>
  </div>
</div>
<hr class="mt-0 pt-0">

<!-- <div class="container-fluid" id="articles">
    <hr class="mt-0">
</div> -->

<div class="container mt-5">
    <div class="text-center mb-5">
        <span class="title">{{'Nos derniers projets R&D' | translate}}</span>
    </div>
    <app-actualites [isRd]="true" [isInterview]="false"></app-actualites>
</div>
